const install = (Vue,) => {
  console.log('[BASE_COMPONENTS] Install',);

  Vue.component('BaseRadioButton', () => import('../components/BaseRadioButton'),);
  Vue.component('BaseRadioButtonSimple', () => import('../components/BaseRadioButtonSimple'),);
  Vue.component('BaseSelectableItems', () => import('../components/BaseSelectableItems'),);
  Vue.component('BaseBlock', () => import('../components/BaseBlock'),);
  Vue.component('BaseAlertBlock', () => import('../components/BaseAlertBlock'),);
  Vue.component('BaseAddressFinder', () => import('@/components/BaseAddressFinder'),);
  Vue.component('BaseAssignmentModal', () => import('@/components/BaseAssignmentModal'),);
  Vue.component('BaseAssignmentTable', () => import('@/components/BaseAssignmentTable'),);
  Vue.component('BaseBadge', () => import ('@/components/BaseBadge'),);
  Vue.component('BaseBarChart', () => import('@/components/BaseBarChart'),);
  Vue.component('BaseBreadcrumb', () => import('@/components/BaseBreadcrumb'),);
  Vue.component('BaseButton', () => import('@/components/BaseButton'),);
  Vue.component('BaseButtonDropdown', () => import('@/components/BaseButtonDropDown'),);
  Vue.component('BaseCard', () => import('@/components/BaseCard'),);
  Vue.component('BaseCheckbox', () => import('@/components/BaseCheckbox'),);
  Vue.component('BaseCheckboxList', () => import('@/components/BaseCheckboxList'),);
  Vue.component('BaseCollapse', () => import('@/components/BaseCollapse'),);
  Vue.component('BaseCounter', () => import('@/components/BaseCounter'),);
  Vue.component('BaseDatepick', () => import('@/components/BaseDatepick'),);
  Vue.component('BaseDatetimePick', () => import('@/components/BaseDatetimePick'),);
  Vue.component('BaseDonutChart', () => import('@/components/BaseDonutChart'),);
  Vue.component('BaseDrawer', () => import ('@/components/BaseDrawer'),);
  Vue.component('BaseDropdown', () => import('@/components/BaseDropDown'),);
  Vue.component('BaseEmptyState', () => import('@/components/BaseEmptyState'),);
  Vue.component('BaseFormGroup', () => import('@/components/BaseFormGroup'),);
  Vue.component('BaseError', () => import('@/components/BaseError'),);
  Vue.component('BaseFormWizard', () => import('@/components/BaseFormWizard'),);
  Vue.component('BaseHistoryModal', () => import('@/components/BaseHistoryModal'),);
  Vue.component('BaseIcon', () => import('@/components/BaseIcon'),);
  Vue.component('BaseImageUpload', () => import ('@/components/BaseImageUpload'),);
  Vue.component('BaseInfo', () => import('@/components/BaseInfo'),);
  Vue.component('BaseInfoModal', () => import('@/components/BaseInfoModal'),);
  Vue.component('BaseInput', () => import('@/components/BaseInput'),);
  Vue.component('BaseLoader', () => import('@/components/BaseLoader'),);
  Vue.component('BaseMap', () => import('@/components/BaseMap'),);
  Vue.component('BaseMapMarker', () => import('@/components/BaseMapMarker'),);
  Vue.component('BaseModal', () => import('@/components/BaseModal'),);
  Vue.component('BaseModalTable', () => import('@/components/BaseModalTable'),);
  Vue.component('BaseModalNew', () => import('@/components/BaseModalNew'),);
  Vue.component('BaseMultiOptions', () => import('@/components/BaseMultiOptions'),);
  Vue.component('BaseNav', () => import('@/components/BaseNav'),);
  Vue.component('BaseNotification', () => import ('@/components/BaseNotification'),);
  Vue.component('BaseOperatingHours', () => import('@/components/BaseOperatingHours'),);
  Vue.component('BaseOptions', () => import('@/components/BaseOptions'),);
  Vue.component('BasePadButton', () => import('@/components/BasePadButton'),);
  Vue.component('BasePagination', () => import('@/components/BasePagination'),);
  Vue.component('BaseRemoteTable', () => import('@/components/BaseRemoteTable'),);
  Vue.component('BaseRemoteList', () => import('@/components/BaseRemoteList'),);
  Vue.component('BaseReportsTable', () => import('@/components/BaseReportsTable'),);
  Vue.component('BaseRequestError', () => import('@/components/BaseRequestError'),);
  Vue.component('BaseSelect', () => import('@/components/BaseSelect'),);
  Vue.component('BaseSelectNew', () => import('@/components/BaseSelectNew'),);
  Vue.component('BaseSidebar', () => import('@/components/BaseSidebar'),);
  Vue.component('BaseSidebarItem', () => import('@/components/BaseSidebarItem'),);
  Vue.component('BaseStraightChart', () => import('@/components/BaseStraightChart'),);
  Vue.component('BaseSwitch', () => import('@/components/BaseSwitch'),);
  Vue.component('BaseTab', () => import('@/components/BaseTab'),);
  Vue.component('BaseTable', () => import('@/components/BaseTable'),);
  Vue.component('BaseTag', () => import('@/components/BaseTag'),);
  Vue.component('BaseTagOptions', () => import('@/components/BaseTagOptions'),);
  Vue.component('BaseTagList', () => import('@/components/BaseTagList'),);
  Vue.component('BaseTermsUse', () => import('@/components/BaseTermsUse'),);
  Vue.component('BaseTextarea', () => import('@/components/BaseTextarea'),);
  Vue.component('BaseTimepick', () => import('@/components/BaseTimepick'),);
  Vue.component('BaseUpload', () => import('@/components/BaseUpload'),);
  Vue.component('BaseSteps', () => import('@/components/BaseSteps'),);
  Vue.component('BaseStepsModal', () => import('@/components/BaseStepsModal'),);
  Vue.component('BaseImagePreview', () => import('@/components/BaseImagePreview'),);
  Vue.component('BaseHarmoWidget', () => import('@/components/BaseHarmoWidget'),);
  Vue.component('BaseCounterDays', () => import('@/components/BaseCounterDays'),);
};

export default { install, };
